import coverImg from '../../../assets/images/literature/coming-round-the-bend-cover.jpg';

const SEGMENTS = [
    {
        id: 'segment-1',
        title: 'Charlie Teede and His Creations',
        stanzas: [1, 2],
        text: `I well remember Charlie Teede,
    Who used to work the races;
No need, indeed, to ask for speed,
    He’d pace it with the pacers.
Lord help the man who “broke” him once
    Or questioned his “creations”;
On him a flood of scorn was turned,
    The atmosphere with brimstone burned,
And Pitman, green with envy, squirmed
    At his abbreviations.

“TE FIELD GOT WL AWA TO TI
    & AS TY SETTLD DWN
TE SHICER 1ST T BK TE LI
    WS FLWD BI JO BROWN.
IN CLOSE PROXIM WS TIRED TIM,
    TN CME ARBTRATN,
BHND TE BUNCH WS CNTR LUNCH,
    GD LUCK AND HI TAXATN.
TY WHIZZED ALNG (and so did Charles)
    WTHOUT TE LEAST CESSATN.”`,
        morseText: `| | I WELL REMEMBER CHARLIE TEEDE BK WHO USED TO WORK THE RACES BK NO NEED INDEED TO ASK FOR SPEED BK HED PACE IT WITH THE PACERS BK LORD HELP THE MAN WHO BROKE HIM ONCE BK OR QUESTIONED HIS CREATIONS BK ON HIM A FLOOD OF SCORN WAS TURNED BK THE ATMOSPHERE WITH BRIMSTONE BURNED BK AND PITMAN GREEN WITH ENVY SQUIRMED BK AT HIS ABBREVIATIONS BK | | TE FIELD GOT WL AWA TO TI BK & AS TY SETTLD DWN BK TE SHICER 1ST T BK TE LI BK WS FLWD BI JO BROWN BK IN CLOSE PROXIM WS TIRED TIM BK TN CME ARBTRATN BK BHND TE BUNCH WS CNTR LUNCH BK GD LUCK AND HI TAXATN BK TY WHIZZED ALNG AND SO DID CHARLES BK WTHOUT TE LEAST CESSATN BK`,
        estimatedSeconds: { wpm15: 160, wpm20: 120, wpm25: 96 },
        questions: [
            {
                id: 'bend-q1',
                question: 'WHO WAS KNOWN FOR HIS SPEED AND ABBREVIATIONS?',
                options: ['PITMAN', 'CHARLIE TEEDE', 'JO BROWN', 'TIRED TIM'],
                answer: 'CHARLIE TEEDE',
                difficulty: 'Beginner'
            },
            {
                id: 'bend-q2',
                question: 'WHO WAS GREEN WITH ENVY AT CHARLIE\'S ABBREVIATIONS?',
                options: ['THE PACERS', 'CHARLES', 'PITMAN', 'JO BROWN'],
                answer: 'PITMAN',
                difficulty: 'Intermediate'
            }
        ]
    },
    {
        id: 'segment-2',
        title: 'Coming Round the Bend',
        stanzas: [3, 4],
        text: `“C R T B TE TOPWT JUMPED
    & GOT ON TRMS WI SHICR,
WO TN & TRE HS BUNDL DUMPD
    WH LABLD HIM A TWICER.”
I scrambled after Charlie
    like a trailer round a bend,
Then gave OK – but queried:
    “C R T B U SEND.
NOW WHAT IS THAT IN AID OF?
    ENLARGE A BIT MY FRIEND.”

The sounder nearly hit the roof
    as Charlie scorched the line:
“U ORT T BE ON TE RABTPROOF
    OR UP AT DOODLEKINE.
CHASIN PODDIES RND TE YD
    SHD B UR CHF PASTIME.
T TNK U CNDT WRK TT OUT
    IT NRLY MKES ME SIK.
ANI OLE GIN OR ROUSABT
    CD WRITE IT WI A STIK.”`,
        morseText: `| | C R T B TE TOPWT JUMPED BK & GOT ON TRMS WI SHICR BK WO TN & TRE HS BUNDL DUMPD BK WH LABLD HIM A TWICER BK I SCRAMBLED AFTER CHARLIE BK LIKE A TRAILER ROUND A BEND BK THEN GAVE OK BT QUERIED BK C R T B U SEND BK NOW WHAT IS THAT IN AID OF BK ENLARGE A BIT MY FRIEND BK | | THE SOUNDER NEARLY HIT THE ROOF BK AS CHARLIE SCORCHED THE LINE BK U ORT T BE ON THE RABTPROOF BK OR UP AT DOODLEKINE BK CHASIN PODDIES RND TE YD BK SHD B UR CHF PASTIME BK T TNK U CNDT WRK TT OUT BK IT NRLY MKES ME SIK BK ANI OLE GIN OR ROUSABT BK CD WRITE IT WI A STIK BK`,
        estimatedSeconds: { wpm15: 180, wpm20: 135, wpm25: 108 },
        questions: [
            {
                id: 'bend-q3',
                question: 'WHAT ABBREVIATION DID THE NARRATOR QUERY?',
                options: ['T N & TRE', 'C R T B', 'WL AWA', 'TOPWT'],
                answer: 'C R T B',
                difficulty: 'Beginner'
            },
            {
                id: 'bend-q4',
                question: 'WHAT HAPPENED TO THE SOUNDER WHEN CHARLIE SENT?',
                options: ['IT NEARLY HIT THE ROOF', 'IT STOPPED WORKING', 'IT SPARKED', 'IT BURNED OUT'],
                answer: 'IT NEARLY HIT THE ROOF',
                difficulty: 'Intermediate'
            }
        ]
    },
    {
        id: 'segment-3',
        title: 'Charlie\'s Scorn and the Reveal',
        stanzas: [5, 6],
        text: `“FANCI A MAN WO CALLS HMSLF
    A TGST ASKG TT!
A RECORD O S VACUUM
    IS LOCATED NEATH UR HAT.
D’ U WANT IT IN OILS BI LAMBERT?
    OR CARVD ON A MARBL STONE?
OLE ‘WINJA’ MORTILL CD TKE IT
    & UD NVR HR A MOAN;
NOT SPELT OUT LI IVE DUN FR U
    BT CUT DWN T TE BONE.

“WL I MST SA ITS TE BST DSPLA
    OF IGNRNCE IVE HRD,
O ALL TE SQRTRS IN W A
    UR CRTNLI TE BIRD
& ANI HRSH REMKS IVE MIST
    TY ALL CN B INFERD
C R T B – ITS KNWN BI ROTE,
    WT WD U HA ME SND?
ITS CMG RND TE BND – U GOAT
    COMING ROUND THE BEND!”`,
        morseText: `| | FANCI A MAN WO CALLS HMSLF BK A TGST ASKG TT BK A RECORD O S VACUUM BK IS LOCATED NEATH UR HAT BK D U WANT IT IN OILS BI LAMBERT BK OR CARVD ON A MARBL STONE BK OLE WINJA MORTILL CD TKE IT BK & UD NVR HR A MOAN BK NOT SPELT OUT LI IVE DUN FR U BK BT CUT DWN T TE BONE BK | | WL I MST SA ITS TE BST DSPLA BK OF IGNRNCE IVE HRD BK O ALL TE SQRTRS IN W A BK UR CRTNLI TE BIRD BK & ANI HRSH REMKS IVE MIST BK TY ALL CN B INFERD BK C R T B ITS KNWN BI ROTE BK WT WD U HA ME SND BK ITS CMG RND TE BND U GOAT BK COMING ROUND THE BEND BK`,
        estimatedSeconds: { wpm15: 180, wpm20: 135, wpm25: 108 },
        questions: [
            {
                id: 'bend-q5',
                question: 'WHAT DOES CHARLIE SAY IS UNDER THE NARRATOR\'S HAT?',
                options: ['A FINE BRAIN', 'A RECORD OF S VACUUM', 'A MORSE KEY', 'AN OLD GIN'],
                answer: 'A RECORD OF S VACUUM',
                difficulty: 'Advanced'
            },
            {
                id: 'bend-q6',
                question: 'FINALLY, WHAT DOES "C R T B" STAND FOR?',
                options: ['COULD READ THE BOOK', 'CAN REALLY TRANSMIT BETTER', 'COMING ROUND THE BEND', 'CROSSING THE BORDER'],
                answer: 'COMING ROUND THE BEND',
                difficulty: 'Beginner'
            }
        ]
    }
];

export default {
    id: 'poem-coming-round-the-bend',
    type: 'poem',
    title: 'Coming Round the Bend',
    author: 'Frank Spruhan',
    publicationDate: '1947',
    coverImage: coverImg,
    genres: ['Narrative Poetry', 'Telegraphy', 'Humor', 'Horse Racing'],
    characterLength: SEGMENTS.reduce((acc, s) => acc + s.text.length, 0),
    description: "A humorous Australian poem about the extreme abbreviations used by experienced operators during horse racing broadcasts.",
    isNew: true,

    text: SEGMENTS.map(s => s.text).join('\n\n'),
    comprehensionQuestions: SEGMENTS.flatMap(s => s.questions),
    segments: SEGMENTS.map(s => ({
        ...s,
        comprehensionQuestions: s.questions.map(q => q.id)
    })),

    metadata: {
        setting: 'Racing Telegraph Office, Western Australia',
        period: 'Late 1940s',
        themes: ['Telegraphic Shorthand', 'Professional Pride', 'Racing Culture', 'Exasperation'],
        difficulty: 'Advanced',
        estimatedReadingTimeMinutes: 4,
        stanzas: 6,
        rhymeScheme: 'Irregular Narrative Verse'
    }
};
